import React, { useState } from 'react';
import { AWS_CRON_DOCS_URL } from '../Constants/SchedulerConstants';
import {
  FormField,
  Textarea,
  Box,
  Link
} from '@amzn/awsui-components-react';

const CronTab = ({ errors, isViewMode, onConfigChange, initialConfig = {} }) => {
  const [cronExpression, setCronExpression] = useState('');

  // Initialize from config
  React.useEffect(() => {
    if (Object.keys(initialConfig).length > 0) {
      setCronExpression(initialConfig.expression || '');
    }
  }, [initialConfig]);

  return (
    <FormField
      label={
        <Box variant="small" color="text-body-secondary">
          Please follow the <Link external href={AWS_CRON_DOCS_URL} fontSize="inherit">AWS EventBridge Cron</Link> format
        </Box>
      }
      errorText={errors.cronExpression}
    >
      <Textarea
        value={cronExpression}
        onChange={({ detail }) => {
          setCronExpression(detail.value);
          onConfigChange({ expression: detail.value });
        }}
        placeholder="Paste your Cron expression here"
        rows={6}
        disabled={isViewMode}
      />
    </FormField>
  );
};

export default CronTab;
